<template>
<div>
    <v-card class="pt-4" flat>
        <v-card :class="(isMultiCond(group[0]) && key > 0 && checkMultiCond(group[0]) ? `act_group_error mb-2 `: ``) + (key > 0 ? `act_group` : ``)" v-for="(group, key) in data" :key="key" elevation="0">
            <v-alert v-if="isMultiCond(group[0]) && key > 0 && checkMultiCond(group[0])" type="error" v-ripple border="left" dense outlined class="ma-2 caption body-2 mb-0 primary--text">
                <div class="second--text">Разом по акції: <span class="font-weight-bold body-1">{{group[0].totalCnt}} шт.</span></div>
                <div v-if="checkMultiCond(group[0])">
                    Умови акції не виконуються. Додайте до замовлення товар з асортименту акції.
                </div>
            </v-alert>
            <v-simple-table v-if="!$vuetify.breakpoint.xs" class="card products">
                <template v-slot:default>
                    <tbody>
                        <tr v-for="item in group" :key="item.typhoon_full_id">
                            <td>
                                <v-img height="80" width="80" class="ma-1" :src="image(item.smallimg)" :lazy-src="nophoto"></v-img>
                            </td>
                            <td width="40%">
                                <div class="my-1">
                                    <ChipsBlock :item="item" />
                                </div>

                                <span @click="goTo(item)" style="text-decoration:none; cursor: pointer" class="font-weight-regular link--text">{{item.name_ukr}}<span v-if="item.is_priceoff"> (<b>SN</b> {{item.priceoff_sn}})</span></span>

                                <v-alert v-if="item.is_promo_action && item.group_id !== -1 && !item.is_priceoff" v-ripple border="left" dense color="accent" class="caption primary--text body-2 ">
                                    <div class="second--text">Застосована акція:
                                        <!-- {{item.prodset_id}} - {{item.group_id}} -->

                                    </div>
                                    <div><a target="_blank" :href="`/action/${item.act_id}`">{{decodeText(item.act_name)}}</a></div>
                                    <div class="second--text">{{actionText(item)}}</div>
                                </v-alert>
                            </td>
                            <td class="text-center">
                                <div>
                                    <div class="grey--text">Ціна</div>
                                    <v-btn title="Ціна контролюється вендором" v-if="item.is_price_roc" color="primary" small icon @click.stop="open_roc_control_dialog(item.price_without_roc_uah.toLocaleString('ru-RU'))">
                                        <v-icon>mdi-alert-circle</v-icon>
                                    </v-btn>
                                    <span :class="item.is_priceoff ? `red--text` : ``">{{ item.is_priceoff ? item.priceoff_price_uah.toLocaleString('ru-RU') : item.price_uah.toLocaleString('ru-RU') }}</span> <span :class="item.is_priceoff ? `body-2 ml-1 red--text` : `body-2 ml-1`">₴</span>
                                </div>
                                <div v-if="(item.price_uah < item.price_uah_without_action && (item.is_actions || item.is_priceoff)) " class="grey--text" style="text-decoration: line-through">{{ item.price_uah_without_action.toLocaleString('ru-RU') }} <span class="ml-1 body-2">₴</span></div>
                            </td>
                            <td>
                                <v-card v-if="item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot" tile elevation="0" height="20" color="transparent">
                                    <div class="caption orange--text text-center">Кратно {{item.act_qty}} шт.</div>
                                </v-card>
                                <div v-else>
                                    <v-card v-if="item.pack > 1 && !item.is_du && !item.is_priceoff" tile elevation="0" height="20" color="transparent">
                                        <div class="caption orange--text text-center">Кратно {{item.pack}} шт.</div>
                                    </v-card>
                                </div>
                                <v-card width="80" class="mx-auto" color="transparent" elevation="0">
                                    <v-btn x-small icon @click.stop="minus(item)">
                                        <v-icon>mdi-minus</v-icon>
                                    </v-btn>
                                    <input v-model="item.cnt" class="inp-cnt" @change="recalcMultipack(item)">
                                    <v-btn x-small icon @click.stop="plus(item)">
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </v-card>
                            </td>
                            <td class="text-center">
                                <div class="grey--text">Сума</div>
                                <div>{{ ((item.is_priceoff ? item.priceoff_price_uah: item.price_uah) * item.cnt).toLocaleString('ru-RU') }} <span class="body-2">₴</span></div>
                            </td>
                            <td class="text-right">
                                <v-btn icon @click="deleteItem(item)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <template v-if="$vuetify.breakpoint.xs">
                <div v-for="item in group" :key="item.typhoon_full_id">
                    <v-list>
                        <v-list-item class="px-0">
                            <v-list-item-avatar class="align-self-start">
                                <v-img :src="image(item.smallimg)" :lazy-src="nophoto"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content class="pa-0">
                                <ChipsBlock :item="item" />
                                <v-list-item-action-text v-text="item.name_ukr" :title="item.name_ukr" @click="goTo(item)" class="font-weight-regular subtitle-2 link--text" style="cursor: pointer;"></v-list-item-action-text>
                                <v-alert v-if="item.is_promo_action" v-ripple border="left" dense color="accent" class="caption primary--text body-2 ">
                                    <div><a target="_blank" :href="`/action/${item.act_id}`">{{item.act_name}}</a></div>
                                    <div class="second--text">{{actionText(item)}}</div>
                                </v-alert>
                            </v-list-item-content>
                            <v-list-item-action class="align-self-start">
                                <v-btn icon @click="deleteItem(item)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>

                        <v-list-item class="px-0">
                            <v-list-item-content class="pa-0">
                                <div class="d-flex justify-space-between align-end my-2">
                                    <div class="d-flex flex-no-wrap align-center ml-2">
                                        <v-btn title="Ціна контролюється вендором" v-if="item.is_price_roc" color="primary" small icon @click.stop="open_roc_control_dialog(item.price_without_roc_uah.toLocaleString('ru-RU'))">
                                            <v-icon>mdi-alert-circle</v-icon>
                                        </v-btn>
                                        <span class="d-flex flex-no-wrap flex-column">
                                            <div v-if="item.price_uah < item.price_uah_without_action && item.is_actions" class="grey--text caption" style="text-decoration: line-through;">{{ item.price_uah_without_action.toLocaleString('ru-RU') }} <span class="ml-1 body-2">₴</span></div>
                                            <div class="d-flex flex-no-wrap">{{ item.price_uah.toLocaleString('ru-RU') }} <span class="body-2 ml-1">₴</span></div>
                                        </span>
                                    </div>
                                    <div>
                                        <v-card v-if="item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot" tile elevation="0" height="20" color="transparent">
                                            <div class="caption orange--text text-center">Кратно {{item.act_qty}} шт.</div>
                                        </v-card>
                                        <div v-else>
                                            <v-card v-if="item.pack > 1 && !item.is_du && !item.is_priceoff" tile elevation="0" height="20" color="transparent">
                                                <div class="caption orange--text text-center">Кратно {{item.pack}} шт.</div>
                                            </v-card>
                                        </div>
                                        <div class="mx-2 d-flex flex-no-wrap align-start">
                                            <v-btn x-small icon @click.stop="minus(item)">
                                                <v-icon>mdi-minus</v-icon>
                                            </v-btn>
                                            <input v-model="item.cnt" class="inp-cnt" @change="recalcMultipack(item)">
                                            <v-btn x-small icon @click.stop="plus(item)">
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-no-wrap mr-2">{{ (item.price_uah * item.cnt).toLocaleString('ru-RU') }} <span class="ml-1 body-2">₴</span></div>
                                </div>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider class="mb-4"></v-divider>
                </div>
            </template>
        </v-card>

    </v-card>
    <!-- Контроль РОЦ -->
    <v-dialog v-model="roc_control_dialog" max-width="290" overlay-opacity="1" overlay-color="grey">
        <v-card>
            <v-card-title class="headline">Ваша цiна:</v-card-title>

            <v-card-text class="headline second--text text-center my-4">
                {{ roc_control_price }} <span class="body-2">₴</span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="roc_control_dialog = false">
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import { decode } from 'html-entities';
import {
    mapActions
} from 'vuex'
import ChipsBlock from './ChipsBlock.vue'
export default {
    components: {
        ChipsBlock
    },
    props: {
        type: String,
    },
    data() {
        return {
            nophoto: 'data:image/png;base64,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',
            roc_control_dialog: false,
            roc_control_price: NaN,
        }

    },
    methods: {
        ...mapActions([]),
        decodeText(text) {
            if (!text) return '';
            return decode(text);
        },
        plus(item) {
            item.cnt = Number(item.cnt)
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot) {
                item.cnt = item.cnt + item.act_qty
                item.cnt = item.cnt - item.cnt % item.act_qty
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff) {
                item.cnt = item.cnt + item.pack
                item.cnt = item.cnt - item.cnt % item.pack
            } else {
                item.cnt++
            }
            this.recalcGiftsQty(item)

        },
        minus(item) {
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && !item.typhoon_check_lot) {
                item.cnt = item.cnt - item.act_qty
                if (item.cnt <= 0) item.cnt = 0
                item.cnt = item.cnt - item.cnt % item.act_qty
                if (item.cnt == 0 && item.cntIn > 0) item.cnt = item.act_qty
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff) {
                item.cnt = item.cnt - item.pack
                if (item.cnt <= 0) item.cnt = 0
                item.cnt = item.cnt - item.cnt % item.pack
                if (item.cnt == 0 && item.cntIn > 0) item.cnt = item.pack
            } else {
                if (item.cntIn > 0 && --item.cnt < 1) {
                    item.cnt = 1
                }
                if (item.cntIn == 0 && --item.cnt < 0) {
                    item.cnt = 0
                }
            }
            this.recalcGiftsQty(item)
        },
        recalcGiftsQty(item) {
            if (this.shoppingCartGiftsData[item.prodset_id]) {
                for (let group_id in this.shoppingCartGiftsData[item.prodset_id]) {
                    const el = this.shoppingCartGiftsData[item.prodset_id][group_id]
                    let qty = el.qty
                    const cnt = this.groupsTotalQty[item.prodset_id]
                    if (!item.typhoon_check_lot) {
                        qty = ((cnt - cnt % item.act_qty) / item.act_qty) * el.qty
                    }
                    this.$set(el, 'qty_total', qty)
                }
            }
        },
        recalcMultipack(item) {
            item.cnt = Number(item.cnt)
            // Если колво/В уп (шт) имеет остаток, то колво = В уп (шт.) * (целое от (колво/В уп (шт)) + 1)
            if (item.act_qty > 1 && item.single_act_cond && item.is_promo_action && !item.is_priceoff && item.cnt % item.act_qty && !item.typhoon_check_lot) {
                item.cnt = item.act_qty * (Number.parseInt(item.cnt / item.act_qty) + 1)
            } else if (item.pack > 1 && !item.is_du && !item.is_priceoff && item.cnt % item.pack) {
                item.cnt = item.pack * (Number.parseInt(item.cnt / item.pack) + 1)
            }
            this.recalcGiftsQty(item)
        },
        image(img) {
            return img ? img : this.nophoto
        },
        deleteItem(item) {
            let _data = []
            Object.keys(this.data).map(key => _data.push(this.data[key]))
            _data = _data.flat(2)
            for (let i in _data) {
                if (item.typhoon_full_id == _data[i].typhoon_full_id) {
                    _data.splice(i, 1)
                    if (this.type == 'available') {
                        this.$store.commit('setShoppingCartAvailable', _data)
                    } else if (this.type == 'preorder') {
                        this.$store.commit('setShoppingCartPreorder', _data)
                    } else if (this.type == 'reserve') {
                        this.$store.commit('setShoppingCartReserve', _data)
                    } else if (this.type == 'absent') {
                        this.$store.commit('setShoppingCartAbsent', _data)
                    }
                }
            }
            this.deleteGifts(item)
        },
        deleteGifts(item) {
            if (this.goodsPrizes[item.typhoon_id]) {
                for (let prodset_id of this.goodsPrizes[item.typhoon_id]) {
                    for (let group_id in this.shoppingCartGiftsData[prodset_id]) {
                        if (this.shoppingCartGiftsData[prodset_id][group_id] && this.shoppingCartGiftsData[prodset_id][group_id].qty_total > 1){
                            this.$set(this.shoppingCartGiftsData[prodset_id][group_id], 'qty_total', this.shoppingCartGiftsData[prodset_id][group_id].qty_total - 1)
                        } else {
                            this.$delete(this.shoppingCartGiftsData, prodset_id)
                        }
                    }
                }
            }
        },
        goTo(item) {
            this.$router.push('/product/' + item.typhoon_full_id)
            this.$store.commit('setShoppingCartDialog', false)
        },
        open_roc_control_dialog(v) {
            this.roc_control_dialog = true
            this.roc_control_price = v
        },
        actionText(item) {
            let text = ''
            const checkLotText = item.typhoon_check_lot ? 'від ' : ''
            if (item.is_spec_action) {
                if (item.act_qty == 1) {
                    text = `Купи за супер ціною!`
                } else {
                    if (item.single_act_cond) {
                        text = `Купи ${checkLotText}${item.act_qty} шт. за супер ціною!`
                    } else {
                        text = `Купи з асортименту ${checkLotText}${item.act_qty} шт. за супер ціною!`
                    }
                }
            } else if (item.is_gift_action) {
                if (item.act_qty == 1) {
                    text = `Купи та отримай подарунок!`
                } else {
                    if (item.single_act_cond) {
                        text = `Купи ${checkLotText}${item.act_qty} шт. та отримай подарунок!`
                    } else {
                        text = `Купи з асортименту ${checkLotText}${item.act_qty} шт. та отримай подарунок!`
                    }
                }
            }
            return text
        },
        isMultiCond(item) {
            return this.type == 'available' && item.act_qty > 1 //&& item.single_act_cond == 0
        },
        checkMultiCond(item) {
            if (item.typhoon_check_lot) {
                return item.totalCnt < item.act_qty ? true : false
            } else {
                return item.totalCnt % item.act_qty ? true : false
            }
        },
    },
    created() {},
    computed: {
        data() {
            let input = []
            if (this.type == 'available') {
                input = this.$store.state.main.shoppingCartAvailable
            } else if (this.type == 'preorder') {
                input = this.$store.state.main.shoppingCartPreorder
            } else if (this.type == 'reserve') {
                input = this.$store.state.main.shoppingCartReserve
            } else if (this.type == 'absent') {
                input = this.$store.state.main.shoppingCartAbsent
            } else {
                input = []
            }
            const data = {}
            for (let el of input) {
                if (!data[el.group_id]) {
                    data[el.group_id] = []
                }
                data[el.group_id].push(el)
            }
            for (let groupId in data) {
                let totalCnt = 0
                for (let item of data[groupId]) {
                    totalCnt = totalCnt + item.cnt
                }
                data[groupId][0].totalCnt = totalCnt
            }
            return data
        },
        actionsConditions() {
            const out = []
            for (let groupId in this.data) {
                let totalCnt = 0
                for (let item of this.data[groupId]) {
                    if (item.totalCnt % item.act_qty) {
                        out.push(groupId)
                    }
                }
            }
            return out
        },
        shoppingCartGiftsData: {
            get: function () {
                return this.$store.state.catalog.shoppingCartGiftsData
            },
            set: function (v) {
                this.$store.commit('setShoppingCartGiftsData', v)
            }
        },
        goodsPrizes() {
            return this.$store.state.catalog.goodsPrizes
        },
        actionGroup: {
            get: function () {
                return this.$store.state.catalog.actionGroup
            },
            set: function (v) {
                this.$store.commit('setActionGroup', v)
            }
        },
        actionProdset: {
            get: function () {
                return this.$store.state.catalog.actionProdset
            },
            set: function (v) {
                this.$store.commit('setActionProdset', v)
            }
        },
        productType() {
            return this.$route.params.id && this.$route.params.id.split('_') || []

        },
        groupsTotalQty() {
            const groupsQty = {}
            for (let groupId in this.data) {
                for (let item of this.data[groupId]) {
                    if (!groupsQty[item.prodset_id]) {
                        groupsQty[item.prodset_id] = 0
                    }
                    groupsQty[item.prodset_id] = groupsQty[item.prodset_id] + item.cnt
                }
            }
            return groupsQty
        },
    },
    watch: {
        '$store.state.main.shoppingCartDialog'(v) {}
    },
}
</script>

<style scoped>
.inp-cnt {
    margin-left: 3px;
    margin-right: 3px;
    border: 1px solid #ccc;
    width: 30px;
    text-align: center;
    padding: 1px;
    border-radius: 4px;
    box-sizing: border-box;
    background: #ffffff;
}

.v-data-table.card.products tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #E3F2FD !important;
}

.act_group_error {
    border: 2px red solid;
}

.act_group .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:last-child>td:not(.v-data-table__mobile-row) {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
</style>
